module.exports = __webpack_public_path__ + "static/media/BSC-blue.d2ac02f9.svg";